import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ChatAdvisor from './components/chat/ChatAdvisor';
import Home from './pages/Home';
import Neighbourhoods from './pages/Neighbourhoods';
import NeighbourhoodDetail from './pages/NeighbourhoodDetail';
import Affordability from './pages/Affordability';
import Invest from './pages/Invest';
import Quiz from './pages/Quiz';
import Compare from './pages/Compare';
import Insights from './pages/Insights';
import InsightDetail from './pages/InsightDetail';
import Dashboard from './pages/Dashboard';
import AdminLeads from './pages/AdminLeads';
import AdminSchools from './pages/AdminSchools';
import AdminSubmissions from './pages/AdminSubmissions';
import AdminNewsletter from './pages/AdminNewsletter';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import RetireeReport from './pages/RetireeReport';
import StrategySession from './pages/StrategySession';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Match from './pages/Match';
import LifestylePage from './pages/LifestylePage';
import BuyerCentre from './pages/BuyerCentre';
import BuyerCentreDetail from './pages/BuyerCentreDetail';
import SellerCentre from './pages/SellerCentre';
import SellerCentreDetail from './pages/SellerCentreDetail';
import HomeValueReport from './pages/HomeValueReport';
import ListingConsultation from './pages/ListingConsultation';
import InvestorCentre from './pages/InvestorCentre';
import InvestmentProjectionCalculator from './pages/InvestmentProjectionCalculator';
import InvestorStrategySession from './pages/InvestorStrategySession';
import NeighbourhoodReport from './pages/NeighbourhoodReport';
import VideoHub from './pages/VideoHub';
import VideoDetail from './pages/VideoDetail';
import AdminVideos from './pages/AdminVideos';
import RegionPage from './pages/RegionPage';
import NotFound from './pages/NotFound';

function Shell() {
    const location = useLocation();
    // Handle OAuth callback synchronously during render — prevents race with /auth/me
    if (location.hash?.includes('session_id=')) {
        return <AuthCallback />;
    }
    return (
        <div className="min-h-screen flex flex-col bg-white text-neutral-900">
            <Header />
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/neighbourhoods" element={<Neighbourhoods />} />
                    <Route path="/neighbourhoods/:slug" element={<NeighbourhoodDetail />} />
                    <Route path="/affordability" element={<Affordability />} />
                    <Route path="/invest" element={<Invest />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/match" element={<Match />} />
                    <Route path="/match/unlock" element={<Match />} />
                    <Route path="/lifestyle/:slug" element={<LifestylePage />} />
                    <Route path="/buyer-centre" element={<BuyerCentre />} />
                    <Route path="/buyer-centre/:slug" element={<BuyerCentreDetail />} />
                    <Route path="/seller-centre" element={<SellerCentre />} />
                    <Route path="/seller-centre/:slug" element={<SellerCentreDetail />} />
                    <Route path="/sellers/home-value-report" element={<HomeValueReport />} />
                    <Route path="/sellers/consultation" element={<ListingConsultation />} />
                    <Route path="/investor-centre" element={<InvestorCentre />} />
                    <Route path="/investor-centre/investment-projection-calculator" element={<InvestmentProjectionCalculator />} />
                    <Route path="/investors/strategy-session" element={<InvestorStrategySession />} />
                    <Route path="/neighbourhoods/:slug/report" element={<NeighbourhoodReport />} />
                    <Route path="/videos" element={<VideoHub />} />
                    <Route path="/videos/:slug" element={<VideoDetail />} />
                    <Route path="/admin/videos" element={<AdminVideos />} />
                    <Route path="/compare" element={<Compare />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/insights/:slug" element={<InsightDetail />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/admin/leads" element={<AdminLeads />} />
                    <Route path="/admin/submissions" element={<AdminSubmissions />} />
                    <Route path="/admin/newsletter" element={<AdminNewsletter />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/admin/schools" element={<AdminSchools />} />
                    <Route path="/retiree-report" element={<RetireeReport />} />
                    <Route path="/strategy-session" element={<StrategySession />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/durham" element={<RegionPage />} />
                    <Route path="/hamilton" element={<RegionPage />} />
                    <Route path="/burlington" element={<RegionPage />} />
                    <Route path="/oakville" element={<RegionPage />} />
                    <Route path="/milton" element={<RegionPage />} />
                    <Route path="/halton-hills" element={<RegionPage />} />
                    <Route path="/brantford" element={<RegionPage />} />
                    <Route path="/brant-county" element={<RegionPage />} />
                    <Route path="/niagara" element={<RegionPage />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <Footer />
            <ChatAdvisor />
            <Toaster position="bottom-right" />
        </div>
    );
}

export default function App() {
    return (
        <HelmetProvider>
            <LanguageProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Shell />
                    </BrowserRouter>
                </AuthProvider>
            </LanguageProvider>
        </HelmetProvider>
    );
}
